import React, { Component } from 'react';

import {handleChange} from 'components/Base/RenderField';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

const COMPONENTS = [
  {
    title: 'Subscription',
    component: 'Subscription'
  }
]

export default class UserDetails extends Component {

  state = {
    data: {},
    errors: {},
    component: 'Subscription',
    error: ''
  }

  handleChange = handleChange.bind(this);

  componentDidMount() {
    this.fetchUser();
  }

  fetchUser = async () => {
    let { id } = this.props.params;

    let result = await api.users.getOne(id);

    if (result.status === 200) {
      return this.setState({data: result.data});
    }

    let errorMsg = getNormalErrors(result).error;
    showNotification(errorMsg, 'error')
  }

  render() {
    let {
      data: {
        name = '',
        surname = '',
        email = ''
      },
      data,
      component
    } = this.state;
    const Component = require(`./${component}`).default;

    return (
      <div className='container user-page'>
        <div className='row'>
          <div className='col-md-4'>
            <div style={{
              padding: '20px',
              minHeight: '400px',
              borderRight: '1px solid rgb(158, 158, 158)'
            }}>
              <div className='row'>
                <div className='col-md-12 m-b-1 b-b-1 p-b-1'>
                  <h4>USER INFO</h4>
                  <div>
                    NAME:
                  </div>
                  <div>
                    {`${name} ${surname}`}
                  </div>
                  <div className='m-t-1'>
                    EMAIL:
                  </div>
                  <div>
                    {email}
                  </div>
                </div>
                <div className='col-md-12'>
                  {
                    COMPONENTS.map(menuItem => {
                      return (
                        <div
                          key={menuItem.component}
                          className={`menu-item ${menuItem.component === component ? 'active' : ''}`}
                          onClick={() => this.handleChange('component', menuItem.component)}
                        >
                          {menuItem.title}
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-8'>
            <div style={{padding: '20px'}}>
              <Component
                data={data}
                fetchUser={this.fetchUser}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Users/Details/index.js